import { render, staticRenderFns } from "./Bunker.vue?vue&type=template&id=70e4aca6&"
import script from "./Bunker.vue?vue&type=script&lang=js&"
export * from "./Bunker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports